import React, { ComponentProps, FC, ReactNode } from 'react';
import { Trans } from '@lingui/macro';
import DialogModal from '@/components/Common/DialogModal';
import LoginForm from '@/components/Common/LoginForm';
import * as styles from './LoginDialog.module.scss';

type Props = Omit<ComponentProps<typeof DialogModal>, 'label' | 'title'> &
  Pick<ComponentProps<typeof LoginForm>, 'onSuccess' | 'isSendingWishlist'> & {
    title?: ReactNode;
  };

const LoginDialog: FC<Props> = ({
  onSuccess,
  isSendingWishlist,
  title = <Trans>Log in your account</Trans>,
  ...props
}) => (
  <DialogModal {...props} className={styles.dialog} label="login-dialog" title={title}>
    <LoginForm
      className={styles.main}
      onSuccess={onSuccess}
      isSendingWishlist={isSendingWishlist}
    />
  </DialogModal>
);

export default LoginDialog;
